export default __webpack_public_path__ + "static/media/elalbergue1.f62d95f5.jpg";